import { oneToWan, secondToDate, formatTime } from './utils'
import Vue from 'vue'
import { sortBy, cloneDeep, sortedIndex } from 'lodash-es'
import {
  UserInfo,
} from '../types'
import api from '@common/api'

// Vue.observable 创建可响应对象
export const store = Vue.observable({
  userInfo: {} as UserInfo,
})

export const mutations = {
  setUserInfo(userInfo: UserInfo) {
    store.userInfo = userInfo
  },
}


export const action = {
  
  async getUserInfo() {
    const res = await api.getUserInfo()
    mutations.setUserInfo(res as UserInfo)
  },
}
